module.exports = __webpack_public_path__ + "img/portal.bf371335.png";